import { Alert, AlertTitle, Box } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { useUser } from "../../hooks/useUser";

export default function ImpersonationBanner() {
  const user = useUser();

  if (!user.isSuperuserImpersonation) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1200, // Below header (1300) but above most content
        width: "100%",
      }}
    >
      <Alert
        severity="warning"
        icon={<WarningIcon fontSize="inherit" />}
        sx={{
          borderRadius: 0,
          borderBottom: 2,
          borderColor: "warning.dark",
          "& .MuiAlert-message": {
            width: "100%",
            textAlign: "center",
          },
        }}
      >
        <AlertTitle sx={{ fontWeight: "bold", mb: 0 }}>
          Impersonation Mode Active
        </AlertTitle>
        You are currently impersonating {user.account.name} - {user.className.name}
      </Alert>
    </Box>
  );
}
